import { createSlice, current } from "@reduxjs/toolkit";

const initialState = {
  headerTitle: "User & Group Management",
  userTabs: {
    activeTab: "0",
    tabs: [
      {
        value: "0",
        label: `User`
      },
      {
        value: "1",
        label: `Group`
      }
    ]
  },
  userDetailsTabs: {
    activeTab: "0",
    type: "details",
    tabs: [
      {
        key: "0",
        label: `User Properties`
      }
      // {
      //   value: "1",
      //   label: `User Settings`,
      // },
    ]
  },

  imageTabs: {
    activeTab: "0",
    tabs: [
      {
        value: "0",
        label: `Image`
      },
      {
        value: "1",
        label: `Group`
      }
    ]
  },

  groupDetailsTabs: {
    activeTab: "0",
    type: "details",

    tabs: [
      {
        key: "0",
        label: `Group Properties`
      }
      // {
      //   value: "1",
      //   label: `Group Settings`,
      // },
    ]
  },
  imageDetailsTabs: {
    activeTab: "0",
    type: "details",
    tabs: [
      {
        key: "0",
        label: `Image Properties`
      }
      // {
      //   value: "1",
      //   label: `Image Settings`,
      // },
    ]
  }
};

export const tabsSlice = createSlice({
  name: "tabs",
  initialState,
  reducers: {
    changeTab: (state, action) => {
      state.userTabs.activeTab = action.payload;
    },
    setHeaderTitle: (state, action) => {
      state.headerTitle = action.payload;
    },
    changeUserDetailsTab: (state, action) => {
      state.userDetailsTabs.activeTab = action.payload;
    },
    changeImageTab: (state, action) => {
      state.imageTabs.activeTab = action.payload;
    },
    changeGroupDetailsTab: (state, action) => {
      state.groupDetailsTabs.activeTab = action.payload;
    },
    changeImageDetailsTab: (state, action) => {
      state.groupDetailsTabs.activeTab = action.payload;
    }
  }
});

export const {
  changeTab,
  changeUserDetailsTab,
  changeImageTab,
  changeGroupDetailsTab,
  setHeaderTitle,
  changeImageDetailsTab
} = tabsSlice.actions;

export default tabsSlice.reducer;
